/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {CreativeBulkActionModalComponent} from './creative-bulk-action-modal.component';

@Injectable({providedIn: 'root'})
export class CreativeBulkActionService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  createBulkAction(list: any): () => void {
    return () => {
      this.angularModalService.show(CreativeBulkActionModalComponent, {
        class: 'modal-lg',
        initialState: {list}
      });
    };
  }
}
